module.exports = {"id":"209281","name":"Yahia Sulaiman Al Shehri","rating":"71","photo":"./data/images/photos/2/209281.png","club":{"name":"CD Leganés","logo":"./data/images/clubs/CDLeganes.png"},"positions":["MOC","MD","MG","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YahiaSulaimanAlShehri0.json
// module id = 4375
// module chunks = 0